// New version src/Common/general_settings/general_settings.service.ts CommonGeneralSettingsService
// Old version src/CaseDotStar.ServicePackages.Frontend.Common/scripts/common/services/common_general_settings_service_facroty.js CommonGeneralSettingsService

import { Injectable } from '@angular/core';

import {
	assign,
	merge,
	get,
} from 'lodash';

import { CommonBootstrapService } from './bootstrap/bootstrap.service';
import { ICommonKeyValues } from '../@types/core';

@Injectable()
export class CommonGeneralSettingsService {
	private generalSettings = {};

	constructor (private commonBootstrapService: CommonBootstrapService) {}

	init (): void {
		const bootstrap = this.commonBootstrapService.getBootstrap<ICommonKeyValues>('GeneralSettings');

		if (bootstrap) {
			this.setGeneralSettings(bootstrap);
		}
	}

	setGeneralSettings (data: Record<string, unknown>): void {
		assign(this.generalSettings, data);
	}

	getGeneralSettings (key?: string) {
		return merge(key ? get(this.generalSettings, key) : this.generalSettings);
	}

	hasMeridiem (): boolean {
		const timeFormat = this.getGeneralSettings('TimeFormat');

		return timeFormat ? !!timeFormat.PmDesignator || !!timeFormat.AmDesignator : false;
	}
}
